












































































































import { Component, Mixins, Watch, Ref } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import RulesMixin from "#/mixins/rulesMixin";
import {
  InquirySubGroup as InquirySubGroupModel,
  InquiryGroup,
} from "@/model/inquiry";
import { VForm } from "@/types";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import AppIconButton from "@/components/admin_common/AppIconButton.vue";

@Component({
  components: {
    AppAuthButton,
    AppIconButton,
  },
})
export default class InquirySubGroup extends Mixins(
  AxiosMixin,
  UtilMixin,
  RulesMixin
) {
  /** Ref */
  @Ref("form") private readonly form!: VForm;

  private dialog = false;
  private valid = false;
  private inquirySubGroups: InquirySubGroupModel[] = [];
  private groups: InquiryGroup[] = [];
  private editedIndex = -1;
  private editedItem: InquirySubGroupModel = {
    id: 0,
    name: "",
    inquiry_group_id: 0,
    sort_no: 0,
    created_at: "",
    updated_at: "",
    deleted_at: "",
  };
  private defaultItem: InquirySubGroupModel = {
    id: 0,
    name: "",
    inquiry_group_id: 0,
    sort_no: 0,
    created_at: "",
    updated_at: "",
    deleted_at: "",
  };

  private headers = [
    { text: "ID", value: "id" },
    {
      text: "サービス種類並び順",
      value: "inquiry_group.inquiry_service_div.sort_no",
      sortable: true,
    },
    {
      text: "問い合わせグループ並び順",
      value: "inquiry_group.sort_no",
      sortable: true,
    },
    { text: "並び順", value: "sort_no" },

    {
      text: "サービス種類名",
      value: "inquiry_group.inquiry_service_div.name",
      sortable: true,
    },
    {
      text: "グループ名",
      value: "inquiry_group.name",
      sortable: true,
    },
    { text: "サブグループ名", value: "name" },
    { text: "操作", value: "actions", sortable: false },
  ];

  get formTitle() {
    return this.editedIndex === -1 ? "新規追加" : "編集";
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    val || this.close();
  }

  created() {
    this.fetchData();
  }

  private fetchData() {
    // グループ取得
    this.postJsonCheck(
      window.base_url + "/api/admin/inquiry_master/inquiry_group/get",
      {},
      (res) => {
        if (res.data && res.data.inquiry_groups) {
          this.groups = res.data.inquiry_groups;
        }
      }
    );

    // サブグループ取得
    this.postJsonCheck(
      window.base_url + "/api/admin/inquiry_master/inquiry_sub_group/get",
      {},
      (res) => {
        if (res.data && res.data.inquiry_sub_groups) {
          this.inquirySubGroups = res.data.inquiry_sub_groups;
        }
      }
    );
  }

  private editItem(item: InquirySubGroupModel) {
    this.editedIndex = this.inquirySubGroups.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  private async deleteItem(item: InquirySubGroupModel) {
    if (await this.$openConfirm("削除しますか？")) {
      this.postJsonCheck(
        window.base_url + "/api/admin/inquiry_master/inquiry_sub_group/delete",
        { inquiry_sub_group: item },
        () => {
          this.fetchData();
        }
      );
    }
  }

  private close() {
    this.dialog = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      if (this.form) {
        this.form.resetValidation();
      }
    });
  }

  private save() {
    if (!this.form.validate()) {
      return;
    }

    const url =
      window.base_url + "/api/admin/inquiry_master/inquiry_sub_group/save";
    this.postJsonCheck(url, { inquiry_sub_group: this.editedItem }, () => {
      this.fetchData();
      this.close();
    });
  }
}
